// recaptcha-client.js (or inline in your component file)
let readyOnce;

export async function getRecaptchaToken(siteKey, action = 'signup', timeoutMs = 6000) {
  if (!window.grecaptcha) throw new Error('grecaptcha not loaded');

  const api = (window.grecaptcha.enterprise?.execute)
    ? window.grecaptcha.enterprise
    : window.grecaptcha;

  if (!readyOnce) {
    // ready() lives on grecaptcha (not enterprise)
    readyOnce = new Promise(r => window.grecaptcha.ready(r));
  }
  await readyOnce;

  const withTimeout = (p, ms) => new Promise((res, rej) => {
    const t = setTimeout(() => rej(new Error('recaptcha-timeout')), ms);
    p.then(v => { clearTimeout(t); res(v); })
     .catch(e => { clearTimeout(t); rej(e); });
  });

  try {
    return await withTimeout(api.execute(siteKey, { action }), timeoutMs);
  } catch {
    // soft retry handles flaky anchor timeouts
    await new Promise(r => setTimeout(r, 300));
    return await withTimeout(api.execute(siteKey, { action }), timeoutMs);
  }
}
